import { TextFieldEntry, SelectEntry } from "@bpmn-io/properties-panel";
import { useService } from "bpmn-js-properties-panel";

export default function ResponsePropertiesProvider(props) {
    const { idPrefix, parameter } = props;

    const entries = [
        {
            id: idPrefix + "-name",
            component: Name,
            idPrefix,
            parameter,
        },
        {
            id: idPrefix + "-description",
            component: Description,
            idPrefix,
            parameter,
        },
        {
            id: idPrefix + "-type",
            component: Type,
            idPrefix,
            parameter,
        },
        {
            id: idPrefix + "-default",
            component: Default,
            idPrefix,
            parameter,
        },
    ];

    return entries;
}

function Name(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                name: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.name;
    };

    return TextFieldEntry({
        element: parameter,
        id: idPrefix + "-name",
        label: `*${translate("Name")}`,
        getValue,
        setValue,
        debounce,
    });
}

function Description(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                description: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.description;
    };

    return TextFieldEntry({
        element: parameter,
        id: idPrefix + "-description",
        label: translate("Description"),
        getValue,
        setValue,
        debounce,
    });
}

function Type(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const types = [];

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                type: value === "" ? undefined : value,
            },
        });
    };

    const getValue = () => {
        return parameter.type;
    };

    const getOptions = () => {
        return [
            { label: translate("<none>"), value: undefined },
            { label: "Text", value: "text" },
            { label: "Number", value: "number" },
            ...types.map((type) => ({
                label: type,
                value: type,
            })),
        ];
    };

    return SelectEntry({
        element: parameter,
        id: idPrefix + "-type",
        label: translate("Type"),
        getValue,
        setValue,
        getOptions,
        debounce,
    });
}

function Default(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                default: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.default;
    };

    return TextFieldEntry({
        element: parameter,
        id: idPrefix + "-default",
        label: translate("Default"),
        getValue,
        setValue,
        debounce,
    });
}
